import { useEffect, useRef, useState } from 'react';
import { IconButton, Input } from '../../../layout/form';
import M from '@materializecss/materialize';

const AddressTab = ({ values, setValues, back, reset, save, stateList }) => {
  const ref = useRef(null);

  const [stateName, setStateName] = useState('');

  const onChange = ({ target: { id, value } }) =>
    setValues(prev => ({ ...prev, [id]: value }));

  useEffect(() => {
    const { current } = ref;
    if (!ref.current || !stateList?.length) return;
    const data = {};
    stateList.forEach(({ name, code }) => (data[`${name} - ${code}`] = null));

    M.Autocomplete.init(current, {
      data,
      onAutocomplete: value => {
        const state = stateList.find(
          ({ name, code }) => `${name} - ${code}` === value
        );
        setStateName(value);
        if (state) setValues(prev => ({ ...prev, stateId: state.id }));
      },
    });

    return () => M.Autocomplete.getInstance(current)?.destroy();
  }, [ref.current, stateList]);

  return (
    <div style={{ padding: '1vw' }}>
      <div className="row">
        <div className="col s4 m3 l2">
          <table>
            <tbody>
              <tr>
                <td style={{ padding: '4px', textAlign: 'right' }}>
                  Address Line One
                </td>
              </tr>
              <tr>
                <td style={{ padding: '4px', textAlign: 'right' }}>
                  Address Line Two
                </td>
              </tr>
              <tr>
                <td style={{ padding: '4px', textAlign: 'right' }}>City</td>
              </tr>
              <tr>
                <td style={{ padding: '4px', textAlign: 'right' }}>State</td>
              </tr>
              <tr>
                <td style={{ padding: '4px', textAlign: 'right' }}>Zip</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="col s8 m9 l10">
          <form>
            <table>
              <tbody>
                <Input
                  id="addressLineOne"
                  type="text"
                  value={values.addressLineOne}
                  onChange={onChange}
                  col="s12 m6 l5"
                />
                <Input
                  id="addressLineTwo"
                  type="text"
                  value={values.addressLineTwo}
                  onChange={onChange}
                  col="s12 m6 l5"
                />
                <Input
                  id="city"
                  type="text"
                  value={values.city}
                  onChange={onChange}
                  col="s12 m6 l5"
                />
                <tr style={{ border: 'none', margin: '0px', padding: '0px' }}>
                  <td style={{ padding: '0px' }}>
                    <div
                      className="input-field"
                      style={{ margin: '0px', padding: '0px' }}
                    >
                      <input
                        ref={ref}
                        id="stateName"
                        type="text"
                        className="col s3 m2 autocomplete"
                        style={{
                          margin: '0px',
                          padding: '0px',
                          height: '30.5px',
                        }}
                        value={stateName}
                        onChange={({ target: { value } }) =>
                          setStateName(value)
                        }
                      />
                    </div>
                  </td>
                </tr>
                <Input
                  id="zip"
                  type="text"
                  value={values.zip}
                  onChange={onChange}
                  col="s12 m6 l5"
                />
              </tbody>
            </table>
          </form>
        </div>
      </div>
      <div className="row" style={{ marginTop: '40px' }}>
        <IconButton icon="arrow_back" onClick={back} />
        <IconButton
          icon="refresh"
          onClick={() => {
            reset();
            setStateName('');
          }}
        />
        <IconButton icon="save" onClick={save} />
      </div>
    </div>
  );
};

export default AddressTab;
